export default "__VITE_ASSET__0ea00702__"